module.exports = __webpack_public_path__ + "img/shift-empty-image.e614fc48.png";